<template>
  <div class="page lightmap">
    <navigation-header />
    <div class="main">
      <h2 class="heading-medium">
        {{ $t('eula.heading') }}
      </h2>
      <heading-chip />
      <div class="subtext-content">
        Updated: {{ $d(new Date(EULA_DATE), 'short') }}
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="policy-content" v-html="eulaHtml" />
    </div>
    <div class="subtext-content">
      {{ EULA_VERSION }}
    </div>
    <accounts-footer />
  </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import NavigationHeader from '../components/NavigationHeader.vue';
import HeadingChip from '../components/HeadingChip.vue';
import AccountsFooter from '../components/AccountsFooter.vue';

const { locale } = useI18n();

// NOTE: reference values need to be manually updated when any of the source documents are modified: eula.*.html
const EULA_DATE = '2026-04-20T00:00:00';     // modification date (time suffix forces local timezone parsing)
const EULA_VERSION = '4138-9764-1562 v.4';   // source document version, for legal reference only

const eulaHtml = ref('');

const htmlModules = import.meta.glob('../../locales/eula.*.html', { query: '?raw', import: 'default' });

watchEffect(async () => {
    const localeFile = `../../locales/eula.${locale.value}.html`;
    const fallbackFile = `../../locales/eula.en.html`;
    const load = htmlModules[localeFile] ?? htmlModules[fallbackFile];
    if (load) {
        eulaHtml.value = await load();
    }
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Accounts' as Accounts;

.page {
  @include Accounts.Default;
  @include Accounts.Container;
}
</style>